import { gql } from "@apollo/client";
import { AnimalEvent } from "../../AnimalDataCalls/GQLCalls/getAnimalCall";

export const ANIMAL_EVENT = gql`
  query Event($domain: String!, $input: BasicQueryInfoInput!, $idIdentifier: String) {
    animal {
      info(domain: $domain, input: $input, idIdentifier: $idIdentifier) {
        animal_id
        event(domain: $domain) {
          timestamp
          eventNo: animal_event_id
          eventName: event_name
          note
        }
      }
    }
  }
`

export const CREATE_ANIMAL_EVENT = gql`
  mutation CreateEvent($domain: String!, $animalid: Int!, $eventdefinitionid: Int!, $timestamp: Int!, $note: String!) {
    animal {
      createEvent(domain: $domain, animalid: $animalid, eventdefinitionid: $eventdefinitionid, timestamp: $timestamp, note: $note) {
        code
        success
        message
      }
    }
  }
`

export interface AnimalEventResponse {
  animal: {
    info: {
      animal_id: number,
      event: AnimalEvent[]
    }[]
  }
}

export interface CreateAnimalEventResponse {
  animal: {
    createEvent: {
      code: string;
      success: boolean;
      message: string;
    }
  }
}